import { Box, Text } from '@factorialco/deprecated-design-system'
import type { Currency } from 'dinero.js'

import i18n from 'modules/core/lib/i18n'

import { getConceptByName, useConcepts } from 'modules/payroll_bundle/hooks/useConcepts'
import { ResultValidation } from 'modules/payroll_bundle/hooks/useResultValidations'
import { DEFAULT_RESULT_CONCEPT, NOT_PAID } from 'modules/payroll_bundle/lib/constants'
import {
  ResultRowData,
  getResultRowDataPaymentStatus,
} from 'modules/payroll_bundle/lib/resultsTableData'
import Validation from 'modules/payroll_bundle/pages/ResultsAndPaymentsPage/ResultsPage/_components/Validation'
import type { Payments } from 'modules/payroll_bundle/store/collections/payments'

import ResultsTabPaymentTypeBlock from './ResultsTabPaymentTypeBlock'

interface Props {
  payments: Payments
  employeeResultRowsData: ResultRowData[]
  policyPeriodIds: { current: number; previous: number }
  validations: ResultValidation[]
  currency: Currency
}

const ResultsTab = ({
  employeeResultRowsData,
  payments,
  currency,
  policyPeriodIds,
  validations,
}: Props) => {
  const { concepts } = useConcepts()
  const netSalaryConcept = getConceptByName(concepts, DEFAULT_RESULT_CONCEPT.net_pay)
  const listSize = validations.length
  const lastPosition = validations.length - 1

  return (
    <Box gap="s16" paddingY="s16">
      {listSize > 0 && (
        <Box gap="s16" paddingX="s24" paddingY="s16">
          <Text.Normal weight="semibold" color="grey1000">
            {i18n.t('payroll_bundle.results_payments.results.validations.validations_applied')}
          </Text.Normal>
          <Box
            border={{
              all: {
                width: 's1',
                color: 'grey400',
                style: 'solid',
              },
            }}
            borderRadius={{
              all: 'abs006',
            }}
          >
            {validations.map((validation, index, list) => (
              <Validation
                key={validation.validation?.id}
                item={validation}
                currency={currency}
                last={lastPosition == index}
                withValidationName
              />
            ))}
          </Box>
        </Box>
      )}

      {employeeResultRowsData.map((resultRowData) => (
        <ResultsTabPaymentTypeBlock
          key={resultRowData.id}
          resultRowData={resultRowData}
          policyPeriodIds={policyPeriodIds}
          paymentStatus={
            netSalaryConcept === null
              ? NOT_PAID
              : getResultRowDataPaymentStatus(
                  resultRowData,
                  payments,
                  policyPeriodIds.current,
                  netSalaryConcept.id,
                  resultRowData.paymentType
                )
          }
          currency={currency}
        />
      ))}
    </Box>
  )
}

export default ResultsTab
